
Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.LateralMenu = (function () {

    function LateralMenu(parentContext) {

        let instanceHistory = null;

        App.Forms.DataImport = App.Forms.DataImport || {};
        App.Forms.DataImport.LateralMenu = this;

        this.createBaseStructure = function() {
            this.rootEl = document.createElement('div');
            this.rootEl.className ='lateralMenu';
        };

        this.setSelected = function(e) {
            var classSelected = ' selected',
                element = e.target;

            //era pra cair aqui sempre que fosse o button, mas as vezes o target é o icone
            if (element.className.indexOf('button') === -1) {
                element = element.parentElement;
            }

            var buttons = element.parentElement.querySelectorAll('.button');
            for(var i = 0; i < buttons.length; i++) {
                buttons[i].className = buttons[i].className.replace(classSelected, '');
            }

            element.className += classSelected;
        };

        this.showHttpScreen = function(e) {
            Greenmile.DataImport.Utils.clearErrorMessage();
            this.setSelected(e);
            parentContext.uploadFile.uploader.disableEvents();
            new Greenmile.DataImport.HTTP().show(parentContext);
        }.bind(this);

        this.showFtpScreen = function(e) {
            Greenmile.DataImport.Utils.clearErrorMessage();
            this.setSelected(e);
            parentContext.uploadFile.uploader.disableEvents();
            new Greenmile.DataImport.FTP().show(parentContext);

        }.bind(this);

        this.showUploadScreen = function(e) {
            Greenmile.DataImport.Utils.clearErrorMessage();
            this.setSelected(e);
            parentContext.uploadFile.show(parentContext);
        }.bind(this);

        this.showHistoryScreen = function(e) {
            this.setSelected(e);
            if(!instanceHistory) {
              instanceHistory = new Greenmile.DataImport.HistoryScreen();
            }
            instanceHistory.clear();
            instanceHistory.show(parentContext);
        }.bind(this);

        this.buttonsParams = {
            upload: {
                className: "upload",
                label: Monet.I18n.getResourcesByKey('Greenmile.DataImport.Menu.upload'),
                clickFunction: this.showUploadScreen
            },
            sftp: {
                className: "sftp",
                label: Monet.I18n.getResourcesByKey('Greenmile.DataImport.Menu.sftp'),
                clickFunction: this.showHttpScreen
            },
            schedules: {
                className: "schedules",
                label: Monet.I18n.getResourcesByKey('Greenmile.DataImport.Menu.schedules'),
                clickFunction: this.showFtpScreen
            },
            history: {
                className: "history",
                label: Monet.I18n.getResourcesByKey('Greenmile.DataImport.Menu.history'),
                clickFunction: this.showHistoryScreen
            }

        };

        this.createUploadTypesButtons = function() {

            if(this.iconsContainer) {
                this.iconsContainer.innerHTML = '';
            }
            this.iconsContainer = document.createElement('div');
            this.iconsContainer.className = "iconsContainer";

            for(var key in  this.buttonsParams) {
                this.iconsContainer.appendChild(createButtons(this.buttonsParams[key]));
            }

            this.rootEl.appendChild(this.iconsContainer);

        };

        var createButtons = function(params) {
            var container = document.createElement('div');
            var image = document.createElement('div');
            var imageLabel = document.createElement('label');

            container.className = 'button';
            image.className = params.className;
            imageLabel.innerHTML = params.label;
            image.setAttribute('title', params.label);

            var stopPropagation = function(e) {
                e.preventDefault();
            };

            container.addEventListener('click', params.clickFunction);
            image.addEventListener('click', stopPropagation);
            imageLabel.addEventListener('click', stopPropagation);

            container.appendChild(image);
            container.appendChild(imageLabel);

            return container;
        };

        this.render = function() {

            this.createBaseStructure();
            this.createUploadTypesButtons();

            return this.rootEl;
        };
    }

    return LateralMenu;
}());
